export enum AssetClass {
    ARS = "ARS",
    PrivateEquity = "Private Equity",
    DigitalAsset = "Digital Asset",
    Infrastructure = "Infrastructure",
    PrivateCredit = "Private Credit",
    RealEstate = "Real Estate"
}